import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SignatureService {
  public static async verifySignature(publicKeyPem: string, signatureBase64: string, data: string) {
    const publicKey = await this.importPublicKey(publicKeyPem);
    const signatureBuffer = this.base64ToArrayBuffer(signatureBase64);
    const dataBuffer = new TextEncoder().encode(data);

    return await crypto.subtle.verify(
      {
        name: 'RSASSA-PKCS1-v1_5',
      },
      publicKey,
      signatureBuffer,
      dataBuffer,
    );
  }

  private static async importPublicKey(pemKey) {
    const pemContents = pemKey.replace('-----BEGIN PUBLIC KEY-----', '').replace('-----END PUBLIC KEY-----', '').replace(/\\s/g, '');
    const binaryDer = this.base64ToArrayBuffer(pemContents);

    return await crypto.subtle.importKey(
      'spki',
      binaryDer,
      {
        name: 'RSASSA-PKCS1-v1_5',
        hash: 'SHA-256',
      },
      true,
      ['verify'],
    );
  }

  private static base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }
}
